/**
 * Check if text-to-speech is available in the browser
 */
export function isTextToSpeechAvailable(): boolean {
  return 'speechSynthesis' in window;
}

/**
 * Speak the provided text using browser's text-to-speech API
 */
export function speakText(text: string): void {
  if (!isTextToSpeechAvailable()) {
    throw new Error('Text-to-speech not available in this browser');
  }

  // Cancel any ongoing speech
  window.speechSynthesis.cancel();

  // Create a new utterance
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = 'en-GB';
  utterance.rate = 0.9;

  // Speak the text
  window.speechSynthesis.speak(utterance);
}

/**
 * Stop any ongoing speech
 */
export function stopSpeech(): void {
  if (isTextToSpeechAvailable()) {
    window.speechSynthesis.cancel();
  }
}
